import * as React from "react"

function Cpy1(props) {
  return (
    <svg
      width={17}
      height={17}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.804 15.353H5.821a.55.55 0 01-.55-.55V5.82a.55.55 0 01.55-.55h8.983a.55.55 0 01.55.55v8.983a.55.55 0 01-.55.55z"
        stroke="#000"
        strokeWidth={1.375}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.77 5.27V1.239a.55.55 0 00-.55-.55H1.239a.55.55 0 00-.55.55v8.983a.55.55 0 00.55.55H5.27"
        stroke="#000"
        strokeWidth={1.375}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default Cpy1
